import React from 'react';
import {LiveSessionBroadcasterSummary} from '../../../../services/liveSessionsApi';
import {getAssetUrl, getDisplayInitial} from '../utils';
import styles from '../Home.module.css';

interface LiveSessionIdentityProps {
  broadcaster: LiveSessionBroadcasterSummary;
  label: string;
}

const LiveSessionIdentity: React.FC<LiveSessionIdentityProps> = ({broadcaster, label}) => {
  const [avatarImageFailed, setAvatarImageFailed] = React.useState(false);
  const avatarUrl = getAssetUrl(broadcaster.profilePicture);
  const showAvatarImage = Boolean(avatarUrl) && !avatarImageFailed;

  React.useEffect(() => {
    setAvatarImageFailed(false);
  }, [avatarUrl]);

  return (
    <div className={styles.liveModalSessionIdentity}>
      <span className={styles.liveModalSessionAvatar}>
        {showAvatarImage ? (
          <img
            src={avatarUrl}
            alt={`${broadcaster.name} avatar`}
            className={styles.liveModalSessionAvatarImage}
            onError={() => setAvatarImageFailed(true)}
          />
        ) : (
          <span aria-hidden="true">{getDisplayInitial(broadcaster.name)}</span>
        )}
      </span>
      <span className={styles.liveModalSessionTitle}>{label}</span>
    </div>
  );
};

export default React.memo(LiveSessionIdentity);
